// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2X_Ne","filesListContainer":"PosDisputesFiles_filesListContainer__3dITW","filesButton":"PosDisputesFiles_filesButton__3ReVA"};